module.exports = __webpack_public_path__ + "img/space.0d9cf466.svg";